import './App.css';
import {LonginesRef} from "./LonginesRef";

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <LonginesRef/>
            </header>
        </div>
    );
}

export default App;
